export const ERROR_TITLES = {
  subscription: {
    cancel: 'Unable to cancel subscription',
  },
};

export const SUCCESS_MESSAGES = {
  subscription: {
    cancel: 'Subscription canceled successfully.',
    resume: 'Subscription resumed successfully.',
  },
};
